import React from "react";

const DrawerTitle = ({ title, subtitle }) => {
    return (
        <div>
            <div style={{ fontWeight: "bold", fontSize: 16 }}>{title}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{subtitle}</div>
        </div>
    );
};

export default DrawerTitle;
